import { CSSProperties } from "react";
import { motion } from "~/utils";
import { FactionType } from "~/business";
import { Colors } from "~/jsx/theme";
import { XCenteredAbsolute } from "../XCenteredAbsolute";
import { XFactionPointSvg } from "./XFactionPointSvg";
import { XVictoryPointSvg } from "./XVictoryPointSvg";

export const XFactionVictoryPoint = ({
  faction,
  style,
  width,
  noAnimation = false,
}: {
  faction: FactionType;
  style?: CSSProperties;
  width: number;
  noAnimation?: boolean;
}) => {
  const { light: lightColor, main: darkColor } = Colors.faction[faction];
  return (
    <motion.div
      style={{ position: "relative", width, height: width, ...style }}
      {...(noAnimation ? {} : { layoutId: `faction-victory-point-${faction}` })}
    >
      <XFactionPointSvg
        darkColor={darkColor}
        lightColor={lightColor}
        style={{ width: "100%", height: "100%" }}
      />
      <XCenteredAbsolute>
        <XVictoryPointSvg width={width * 0.5} />
      </XCenteredAbsolute>
    </motion.div>
  );
};
